export default __webpack_public_path__ + "static/media/serviciosAlarma2Mobile.cad2811d.png";